import { render, staticRenderFns } from "./user-header-info.vue?vue&type=template&id=8a8d0750&scoped=true"
import script from "./user-header-info.ts?vue&type=script&lang=js&external"
export * from "./user-header-info.ts?vue&type=script&lang=js&external"
import style0 from "./user-header-info.vue?vue&type=style&index=0&id=8a8d0750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8d0750",
  null
  
)

export default component.exports